<template>
  <div class="inputComponent">
    <div v-if="!showEdit" class="inputComponent__textBlock">
      <div v-for="(name, index) in names" v-bind:key="index">
        <span :title="title_name" :class="h_class_name">{{ name }}</span>
      </div>
      <div v-if="checkScopes()" @click="showEdit = true" class="inputComponent__svg">
        <SvgEdit :class="svgClass" :title="title_name"> </SvgEdit>
      </div>
    </div>
    <div v-else class="inputComponent__updateBlock">
      <div v-for="(name, index) in names" v-bind:key="index">
        <SmallInput :name="name" class="pr-2" @update:field="updateInput(index, $event)"> </SmallInput>
      </div>
      <div class="btnCustom btnCustom-bg btnCustom__outline btnCustom__danger-outline" @click="makeClosed()">
        {{ $t('Cancel') }}
      </div>
      <div @click="save()" class="btnCustom btnCustom-bg btnCustom__confirm">
        {{ button_name }}
      </div>
    </div>
  </div>
</template>

<script>
import SvgEdit from '../svg/SvgEdit';
import SmallInput from './SmallInput';
import scopesChecker from '../../router/scopes/scopesChecker';
export default {
  name: 'showOrUpdateInput',
  components: {
    SmallInput,
    SvgEdit,
  },
  props: ['open', 'title_name', 'names', 'button_name', 'h_class_name', 'input_class_name', 'id', 'action', 'svgClass'],
  data: function () {
    return {
      showEdit: false,
      new_names: {},
    };
  },
  mounted() {},
  methods: {
    makeClosed: function () {
      this.showEdit = false;
      this.new_names = {};
    },
    checkScopes: function () {
      return scopesChecker(null, this.$route.name, this.action);
    },
    updateInput: function (index, event) {
      this.new_names[index] = event;
    },
    save: function () {
      this.showEdit = false;
      this.$emit('update', this.new_names);
    },
  },
};
</script>

<style scoped></style>
